
export default {
  name: 'VsSkeletonItem',
  inheritAttrs: false,
  inject: ['skeleton'],
  props: {
    type: {
      type: String,
      default: 'text'
    },
    ratio: {
      type: [String, Object],
      default: '4/3'
    }
  },
  vessel: {
    item: {
      $animated: {
        backgroundColor(value) {
          return value ? 'grey-lightest' : 'grey-lighter'
        }
      },
      borderRadius() {
        return this.radius ? true : false
      },
      width: 'full'
    },
    image: {
      $extend: 'item',
      height: 'full'
    },
    text: {
      $extend: 'item',
      height: 'xs'
    },
    title: {
      $extend: 'text',
      width: '1/2',
    },
    paragraph: {
      $extend: 'text'
    },
    button: {
      $extend: 'item',
      width: 'xl',
      height: 'sm'
    },
    box: {
      $extend: 'item',
      height: 'full'
    },
    circle: {
      $extend: 'item',
      borderRadius: 'full',
      height: 'full'
    },
  },
  computed: {
    animated() {
      return this.skeleton.isAnimated
    },
    radius() {
      return this.skeleton.radius
    },
    classes() {
      const vessel = this.$vessels[this.type] || this.$vessels.item
      return { skeleton: this.animated, ...vessel }
    }
  }
}
